import React, { FC, useEffect,useState } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import imagePng from "images/hero-right.png";
import HeroSearchForm from "components/HeroSearchForm/HeroSearchForm";
import Logo from "shared/Logo/Logo";
import config from "config.json";
import useFetch from "hooks/useFetch";
export interface SectionHeroProps {
  className?: string;
}


interface Hotel {
  hotel_code: string;
  photos: string[];
}

interface HotelData {
  default_image: string;
  hoteles: Hotel[];
}

interface Template {
  
  id: string;
  pagina: string;
  titulo: string;
  descripcion: string;
  cuerpo?: string;

}



const SectionHero: FC<SectionHeroProps> = ({ className = "" }) => {
  const [imagen, setImagen] = useState<string>("")

  const [template, setTemplate] = useState<Template[] >([])
  const {data: dataTemplate, error: errorTemplate, fetchData: fetchDataTemplate} = useFetch(
    'POST',
    `${config.backend_url}/setia_administrator/template/get`,
    {
      "pagina" : "Inicio",
      "descripcion": "home",
      "titulo": "home"
    },
    {}
  )

  useEffect(() => {
    if(dataTemplate){
      const response = dataTemplate as any;
      setTemplate(response.content)
      
    }
    if(errorTemplate){
      console.log(errorTemplate)
    }
  }, [dataTemplate,errorTemplate])

  const obtenerImagenHome = async() => {
    const response = await fetch(`${config.backend_url}/setia/hoteles/lista_fotos?tipo=home`) 
    const data: HotelData = await response.json()
    if (data.hoteles.length === 0){
      setImagen(data.default_image)
    }else{
     setImagen(data.hoteles[0].photos[0])
    } 
  }
  
  useEffect(() => {
    obtenerImagenHome()
    fetchDataTemplate()
  },[])

  return (
    <div
      className={`nc-SectionHero flex flex-col-reverse lg:flex-col relative ${className}`}
      data-nc-id="SectionHero"
    >
      <div className="flex flex-col lg:flex-row lg:items-center">
        <div className="flex-shrink-0 lg:w-1/2 flex flex-col items-start space-y-8 sm:space-y-10 pb-14 lg:pb-64 xl:pr-14 lg:mr-10 xl:mr-0">
          <h2 className="font-medium text-4xl md:text-5xl xl:text-7xl !leading-[114%] ">
            {' '}Recorré el país con <Logo className="h-12 ml-0 align-middle justify-start"/>
          </h2>
          <span className="text-base md:text-lg text-neutral-500 dark:text-neutral-400">
             {
                (template.length > 0) && 
                <div style={{margin: '0px'}} dangerouslySetInnerHTML={{ __html: template[0]?.cuerpo || ""}} />
              }
          </span>
        </div>
        <div className="flex-grow">
          <img className="w-full" src={imagen} alt="hero" />
        </div>
      </div>

      <div className="hidden lg:block z-10 mb-12 lg:mb-0 lg:-mt-40 w-full">
        <HeroSearchForm />
      </div>
    </div>
  );
};

export default SectionHero;
